import React from 'react';
import {connect} from 'react-redux';
import {ADDSCHOOLS, VIEWSCHOOLS} from 'constants/index';
import './styles.scss';
import strings from 'utils/strings';
import moment from 'moment';
import getFeideTwoSchools from 'api/getFeideTwoSchools';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPenToSquare, faTrash} from '@fortawesome/free-solid-svg-icons';
import AddSchool from './addSchool';
import InformationPane from 'components/InformationPane';
import AlertBox from 'components/CreateNotification/alert';
import deleteFeideTwoSchool from 'api/deleteFeideTwoSchool';
import EditSchoolModal from './editSchoolModal';

const feideSchoolFilters = [VIEWSCHOOLS, ADDSCHOOLS];

class FeideTwoSchools extends React.Component {
	constructor() {
		super();

		this.state = {
			activeFilter: VIEWSCHOOLS,
			schools: [],
			renderPaneAlert: false,
			paneMessage: strings.warning_deleteSchool,
			isEditModelOpen: false,
			showAlert: false,
		};
		this.fetchSchools = this.fetchSchools.bind(this);
		this.onEditItemClick = this.onEditItemClick.bind(this);
		this.onListItemDelete = this.onListItemDelete.bind(this);
	}

	componentDidMount() {
		this.fetchSchools();
	}

	showTimedAlert({error, success, message}) {
		this.setState({
			showAlert: true,
			error,
			success,
			message,
		});
		setTimeout(() => {
			this.setState({
				showAlert: false,
			});
		}, 3000);
	}

	fetchSchools() {
		this.setState({
			isEditModelOpen: false,
		});
		return getFeideTwoSchools()
			.then((schools) => {
				this.setState({
					schools: Array.isArray(schools) ? schools : [],
				});
			})
			.catch(() => {
				this.showTimedAlert({
					error: true,
					success: false,
					message: strings.opsSomethingWentWrong,
				});
			});
	}

	onEditModelConfirm = () => {
		this.setState({
			isEditModelOpen: false,
		});
	};

	onEditModelCancel = () => {
		this.setState({
			isEditModelOpen: false,
		});
	};

	onEditItemClick = (id, schools) => {
		const selectedSchool = schools.find((item) => item.id === id);

		if (!selectedSchool) {
			return;
		}

		this.setState({
			isEditModelOpen: true,
			selectedSchool,
		});
	};

	onListItemDelete = (id) => {
		deleteFeideTwoSchool(id)
			.then((res) => {
				if (!res) {
					this.showTimedAlert({
						error: true,
						success: false,
						message: strings.opsSomethingWentWrong,
					});
					return;
				}

				this.showTimedAlert({
					error: false,
					success: true,
					message: strings.schoolDeleted,
				});
				this.fetchSchools();
			})
			.catch(() => {
				this.showTimedAlert({
					error: true,
					success: false,
					message: strings.opsSomethingWentWrong,
				});
			});
	};

	render() {
		const {
			schools,
			activeFilter,
			selectedSchool,
			selectedSchoolId,
			renderPaneAlert,
			isEditModelOpen,
			showAlert,
			success,
			message,
		} = this.state;

		return (
			<div className="lit-all-tests">
				<div className="lit-filters-row">
					<div className="lit-dropdown_filter">
						<select
							className="lit-input__field"
							value={activeFilter.id}
							onChange={(e) => {
								this.setState({
									activeFilter: feideSchoolFilters.filter(
										(filter) =>
											filter.id === e.target.value
									)[0],
								});
							}}
						>
							{feideSchoolFilters.map((userStageFilter) => (
								<option
									key={userStageFilter.id}
									value={userStageFilter.id}
								>
									{userStageFilter.label ||
										userStageFilter.text}
								</option>
							))}
						</select>
					</div>
				</div>
				{activeFilter === VIEWSCHOOLS && (
					<div>
						{Boolean(schools.length < 1) && (
							<p>{strings.noSchoolsFound}</p>
						)}
						{Boolean(schools.length) && (
							<div className="main">
								<table className="list">
									<thead>
										<tr>
											<th>{strings.createdAt}</th>
											<th>{strings.schoolName}</th>
											<th>
												{strings.municipalityNumber}
											</th>
											<th>{strings.actions}</th>
										</tr>
									</thead>
									<tbody>
										{schools.map((item) => {
											const {
												id,
												school,
												uuid,
												createdAt,
											} = item;

											return (
												<tr
													className="lit-list__item"
													key={id}
												>
													<td>
														{moment(
															createdAt
														).format('LLL')}
													</td>
													<td>{school}</td>
													<td>{uuid}</td>
													<td>
														<div className="action-buttons">
															<button
																type="button"
																className="edit-button"
																title={
																	strings.editSchoolTitle ||
																	strings.editMunicipalityTitle
																}
																onClick={() => {
																	this.onEditItemClick(
																		id,
																		schools
																	);
																}}
															>
																<FontAwesomeIcon
																	size="lg"
																	className="lit-mytests-header-mytest-icon-btn-icon"
																	icon={
																		faPenToSquare
																	}
																/>
															</button>
															<button
																type="button"
																className="delete-button"
																title={
																	strings.deleteSchoolTitle ||
																	strings.deleteMunicipalityTitle
																}
																onClick={() => {
																	this.setState(
																		{
																			renderPaneAlert: true,
																			selectedSchoolId: id,
																		}
																	);
																}}
															>
																<FontAwesomeIcon
																	size="lg"
																	className="lit-mytests-header-mytest-icon-btn-icon"
																	icon={
																		faTrash
																	}
																/>
															</button>
														</div>
													</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							</div>
						)}
					</div>
				)}
				{activeFilter === ADDSCHOOLS && (
					<AddSchool refreshSchools={this.fetchSchools} />
				)}
				{renderPaneAlert && (
					<InformationPane
						paneMessage={this.state.paneMessage}
						onApproval={() => {
							this.setState({
								renderPaneAlert: false,
							});
							this.onListItemDelete(selectedSchoolId);
						}}
						onCloseWindow={() => {
							this.setState({
								renderPaneAlert: false,
							});
						}}
						onDisproval={() => {
							this.setState({
								renderPaneAlert: false,
							});
						}}
						category={'confirmation'}
					/>
				)}
				{isEditModelOpen && (
					<EditSchoolModal
						onConfirm={this.onEditModelConfirm}
						onCancel={this.onEditModelCancel}
						selectedSchool={selectedSchool}
						refreshSchools={this.fetchSchools}
					/>
				)}
				{showAlert && (
					<AlertBox
						type={success ? 'success' : 'error'}
						message={message}
					/>
				)}
			</div>
		);
	}
}

const mapStateToProps = () => {
	return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(FeideTwoSchools);
